
        import 'MainNav.5a7458e.css-module'
        export default {"MainNav":"MainNav_MainNav_5a7458e","active":"active_MainNav_5a7458e"}
    